import {Stack, List, Button} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {type Alias} from 'client';
import {CompanyAliasListRow} from './CompanyAliasListRow';
import {SectionHeader} from 'components/Generic/SectionHeader';
import {SectionDescription} from 'components/Generic/SectionDescription';
import {CompanyAliasModal} from 'components/Companies/CompanyAliasModal';
import {useModalWindow} from 'hooks/useModalWindow';

export const CompanyAliasList = ({
  companyAliases,
  setCompanyAliases,
}: {
  companyAliases?: Alias[];
  setCompanyAliases: (companyAliases: Alias[]) => void;
}) => {
  const {t} = useTranslation('common');
  const {openModalWindow} = useModalWindow();

  const addAlias = (): void => {
    openModalWindow(CompanyAliasModal, {
      onClose: ({parameters}: {parameters: Alias}) => {
        setCompanyAliases([parameters, ...(companyAliases ?? [])]);
      },
    });
  };

  const removeAlias = (alias: Alias): void => {
    companyAliases && setCompanyAliases(companyAliases.filter((value) => value !== alias));
  };

  return (
    <Stack>
      <SectionHeader label={t('aliases')} />
      <SectionDescription label={t('aliasesDescription')} />
      <List dense={true}>
        {companyAliases &&
          companyAliases.map((alias, index) => (
            <CompanyAliasListRow key={`alias-${index}`} alias={alias} removeAlias={removeAlias} />
          ))}
      </List>
      <Button color="primary" variant="outlined" onClick={addAlias} data-testid="add-alias-button">
        {t('add')}
      </Button>
    </Stack>
  );
};
